import { compose, withFieldValidation } from "@transformd-ltd/sdk";
import { TimePicker as AntdTimePicker } from "antd";
import "antd/dist/antd.css";
import moment from "moment";
import React, { useEffect } from "react";

const TimePicker = (props) => {
  const { getData, value, id, attributes, errors } = props;

  const handleChange = (newValue) => {
    getData().setFieldValue(id, newValue);
  };
  console.log({ props });
  console.log({ value });

  const parsedValue = value ? moment(value, "HH:mm") : undefined;

  const validate = (value, ...args) => {
    console.log("PERFORMING VALIDATION");
    const VALIDATION_ERROR_MESSAGE = "Please select an option";
    const returnData = {
      isValid: true,
      inputError: false,
      displayErrorMessage: false,
    };

    if (!value) {
      returnData.isValid = false;
      returnData.inputError = VALIDATION_ERROR_MESSAGE;
      returnData.displayErrorMessage = VALIDATION_ERROR_MESSAGE;
    }

    return returnData;
  };

  useEffect(() => {
    if (props.registerValidator && props.attributes.required) {
      props.registerValidator((value, ...args) => validate(value, ...args), id);
    }
  }, []);

  return (
    <div id="custom-timepicker">
      <div
        class="formatic-field-container col-2 mr"
        data-id={id}
        data-renderer="custom-timepicker"
        name={id}
        data-tag={attributes.tag}
      >
        <label
          class="formatic-label formatic-field-label formatic-text__label"
          for={id}
        >
          <span class="formatic-label__content">{attributes.label}</span>
          <span class="formatic-label__required"> *</span>
        </label>
        <div class="formatic-field-container__field">
          <div class="formatic-custom-timepicker">
            <AntdTimePicker
              value={parsedValue}
              onChange={(val) => handleChange(val.format("HH:mm"))}
              defaultValue={moment()}
              use12Hours
              format="h:mm a"
              size="small"
              allowClear="false"
            />
          </div>
          {errors?.value && (
            <div className="formatic-error-message">{errors.value}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default compose(withFieldValidation)(TimePicker);
